import { Command } from '@/app/tracking/api';
import { Bookmark } from './bookmark-state'

export interface UpdateBookmarkTrackingCommandPayload {
  bookmark: Bookmark
}

export const UpdateBookmarkTrackingCommandName = 'update-bookmark' as const;
export type UpdateBookmarkTrackingCommand =
      Command<typeof UpdateBookmarkTrackingCommandName, UpdateBookmarkTrackingCommandPayload>;
